import type { MouseEvent } from 'react';

import AIIcon from '@/components/Badge/AIBadge/AIIcon';
import { Flex } from '@/components/base';
import Dropdown from '@/components/Dropdown/Dropdown';
import MenuItem from '@/components/Menu/MenuItem';
import Typo from '@/components/Typography/Typo';

type Props = {
  pos: {
    top: number;
    left: number;
  };
  status: boolean;
  close: () => void;
  onViewFeedbackListClick: (e: MouseEvent) => void;
  onAddToFilterClick?: (e: MouseEvent) => void;
  onAskSynclyAIClick: (e: MouseEvent) => void;
};

const SearchDrilldownMenu = (props: Props) => {
  return (
    <Dropdown
      modalWidth="150px"
      triggerPos={{
        top: props.pos?.top,
        left: props.pos?.left,
      }}
      style={{
        padding: 4,
      }}
      status={props.status}
      close={props.close}
    >
      <MenuItem
        id="Ask Syncly AI"
        onClick={props.onAskSynclyAIClick}
        node={
          <Flex a="center" g={6}>
            <AIIcon className="text-xl" />
            <Typo type="label2" weight="r">
              Ask Syncly AI
            </Typo>
          </Flex>
        }
      />
      <MenuItem
        id="View feedback list"
        onClick={props.onViewFeedbackListClick}
        node="View feedback list"
      />
      {props.onAddToFilterClick && (
        <MenuItem
          id="Add to filter"
          onClick={props.onAddToFilterClick}
          node="Add to filter"
        />
      )}
    </Dropdown>
  );
};

export default SearchDrilldownMenu;
